import { Injectable, computed, effect, signal } from '@angular/core';
import { Kit } from '../models/kit.model';

export interface CartSelection {
  flavorId: string;
  flavorName: string;
  quantity: number;
}

export interface CartItem {
  kit: Kit;
  // Quantidade escolhida de cada sabor (definida no montador de kit)
  selections: CartSelection[];
}

const CART_KEY = 'cart_items';

@Injectable({ providedIn: 'root' })
export class CartService {
  readonly items = signal<CartItem[]>(this.readStoredCart());
  readonly count = computed(() => this.items().length);
  readonly totalAmount = computed(() =>
    this.items().reduce((total, item) => total + Number(item.kit.pricePer100), 0)
  );

  constructor() {
    // Mantém o carrinho ao recarregar a página (ex.: ida e volta do login)
    effect(() => localStorage.setItem(CART_KEY, JSON.stringify(this.items())));
  }

  addToCart(item: CartItem) {
    this.items.update(items => [...items, item]);
  }

  removeFromCart(index: number) {
    this.items.update(items => items.filter((_, i) => i !== index));
  }

  clearCart() {
    this.items.set([]);
  }

  private readStoredCart(): CartItem[] {
    try {
      const stored = JSON.parse(localStorage.getItem(CART_KEY) ?? '[]');
      return Array.isArray(stored) ? stored : [];
    } catch {
      return [];
    }
  }
}
